import React from 'react'
import { trackECommerceEvent } from '~/tools/analytics/googleAnalytics'
import Spinner from '~/components/Spinner'
import getQueryVariable from '~/tools/getQueryVariable'
import popup from '~/views/Popup/popup'
import { trackEvent } from '~/tools/analytics/cleverTap'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import includes from 'lodash/includes'

import './style.css'
import { successIcon, failureIcon } from '~/components/JusPay/paymenticons';
import { getLocalizedVal } from '~/tools/localization/helpers';
import Cookies from 'js-cookie'
import { trackAdwordsEvent, ecommerceEvent } from '~/tools/analytics/gtmTags';

class Notice extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      paymentHandler: null,
      loading: true
    }
  }

  componentDidMount() {
    this.dataLayer = window.dataLayer || { push: _ => { } }
    this.interval = setInterval(() => this.refresh(), 500)
    getCountryCode().then(country => {
      if (window.settings.paymentProviders && window.settings.paymentProviders.juspay && window.settings.paymentProviders.juspay.country === country) { // When JusPay enabled

        return this.setState({ paymentHandler: 'juspay' });

      } else { // When JusPay is not enabled then Either ccavenue or SSL or Stripe will run
        var providers = window.settings.paymentProviders
        for (var k in providers) {
          if (includes(providers[k].country, country)) {

            return this.setState({ paymentHandler: k })
          }
        }
        for (k in providers) {
          if (includes(providers[k].country, 'ROW')) {

            return this.setState({ paymentHandler: k })
          }
        }

        return this.setState({ paymentHandler: 'stripe' })
      }
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState !== this.state && this.state.paymentHandler) {
      this.trackCT(prevProps, prevState)
      this.trackFbEvent(prevProps, prevState)
      /*********** Start GTM Event *************/
      this.gtmTagsEvents();
      /*********** End GTM Event *************/
    }
  }

  trackCT = () => {
    const subscriptionInfo = JSON.parse(localStorage.getItem('planDetails'))
    const userInfo = JSON.parse(localStorage.getItem('user'))
    let pageType = document.location.pathname;
    pageType = pageType.substr(1);
    var initiateSubscriptionEventData = {
      userId: userInfo.user.userId,
      planId: subscriptionInfo.id,
      paymentHandler: this.state.paymentHandler,
      platform: 'Web',
      transactionAmount: subscriptionInfo.planDetails[0].recurringPaymentAmount,
      pageType: pageType
    }

    let message = '';
    let eventName = '';
    const title = decodeURIComponent(getQueryVariable('title'))
    if (title.includes('Thank')) {
      message = 'Subscription Plan Status Success';
      eventName = 'SUBSCRIPTION_COMPLETED';
    } else if (title.includes('Subscription')) {
      message = 'Subscription Plan Status Failure';
      eventName = 'SUBSCRIPTION_FAILURE';
      
    }

    if (!this.state.loading && this.state.paymentHandler) {
      trackEvent(message, initiateSubscriptionEventData)
      trackEvent(eventName, initiateSubscriptionEventData)

    }
  }

  trackFbEvent = () => {
    const socialMedia = window.settings.socialMedia
    const facebook = socialMedia && socialMedia.facebook 
    const pixelId = facebook && facebook.pixelId
    const subscriptionInfo = JSON.parse(localStorage.getItem('planDetails'))
    var initiateSubscriptionEventData = {
      transactionAmount: subscriptionInfo.planDetails[0].recurringPaymentAmount,
      currencyCode: subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode
    }
    let eventName = '';
    const title = decodeURIComponent(getQueryVariable('title'))
    if (title.includes('Thank')) {
      eventName = 'Purchase'
    if (pixelId && !this.state.loading && this.state.paymentHandler) {
      window.fbq('track', eventName, { 'value': initiateSubscriptionEventData.transactionAmount, 'currency': initiateSubscriptionEventData.currencyCode })
    }
    }
  }

  refresh() {
    if (this.dataLayer) {
      clearInterval(this.interval)
      this.setState({ loading: false })
      this.sendEvents()
    }
  }

  gtmTagsEvents = () => {
    let eventName;
    const orderId = Cookies.get('order_id') ? Cookies.get('order_id') : ''
    const subscriptionInfo = localStorage.getItem('planDetails') ? JSON.parse(localStorage.getItem('planDetails')) : '';
    const title = decodeURIComponent(getQueryVariable('title'))
    const userInfo = JSON.parse(localStorage.getItem('user'))

    if (title.includes('Thank')) {
      eventName = 'Subscription success'

      const eventData = {
        'Name': userInfo.user.name,
        'Email': userInfo.user.email,
        'userId': userInfo.user.userId,
        'localCurrency': subscriptionInfo && subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode,
        'plan_price': subscriptionInfo && subscriptionInfo.planDetails[0].recurringPaymentAmount,
        'transactionId': orderId
      };
      trackAdwordsEvent(eventData);
    } else if (title.includes('Subscription')) {
      eventName = 'Subscription failed'
    } else if (title.includes('Pending')) {
      eventName = 'Subscription pending'
    }
    
    const dt = new Date();
    const currentDate =  dt.getDate() + "/" + dt.getMonth() + "/" + dt.getFullYear();

    const eventItems = {
      'Name': userInfo.user.name,
      'Email': userInfo.user.email,
      'userId': userInfo.user.userId,
      'subscriptionPlan': (subscriptionInfo && subscriptionInfo.planDetails[0].description) || (subscriptionInfo && subscriptionInfo.description),
      'subscriptionStartDate': currentDate,
      'subscriptionEndDate': subscriptionInfo && subscriptionInfo.planDetails[0].title,
      'transactionAmount': subscriptionInfo.planDetails[0].recurringPaymentAmount,
      'paymentHandler': this.state.paymentHandler,
      'subscribed_via_platform': 'Web',
      'subscribed_from_country': subscriptionInfo && subscriptionInfo.planDetails[0].countryCode,
      'localCurrency': subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode,
      'transactionId': orderId
    } 

    ecommerceEvent(eventName, eventItems)
  }

  sendEvents() {
    const title = decodeURIComponent(getQueryVariable('title'))
    const status = decodeURIComponent(getQueryVariable('status'))
    if (title.includes('Thank')) {
      const ga = window.ga;
      const dataLayer = this.dataLayer || { push: _ => { } }
      const subscriptionInfo = JSON.parse(localStorage.getItem('planDetails'))
      const userInfo = JSON.parse(localStorage.getItem('user'))
      ga("ec:setAction", "checkout", { 'step': 3 })
      trackECommerceEvent('ec:addProduct', {
        id: subscriptionInfo.id ? subscriptionInfo.id : '',
        name: subscriptionInfo.name,
        price: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        quantity: 1
      })
      ga("send", "event", "e-commerce", "checkout", "3")
      ga("ec:setAction", "purchase", {
        revenue: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        id: `${userInfo.user.userId} - ${Date.now()}`
      })
      trackECommerceEvent('ec:addProduct', {
        id: subscriptionInfo.id ? subscriptionInfo.id : '',
        name: subscriptionInfo.name,
        price: subscriptionInfo.planDetails[0].recurringPaymentAmount,
        quantity: 1
      })
      ga('set', 'currencyCode', subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode)
      ga('send', 'event', 'e-commerce', 'purchase')
      dataLayer.push({
        "event": "finish_subscription",
        "plan_currency_code": subscriptionInfo.planDetails[0].recurringPaymentCurrencyCode,
        "plan_uuid": subscriptionInfo.id ? (subscriptionInfo.id) : '',
        "plan_name": subscriptionInfo.name,
        "plan_price": subscriptionInfo.planDetails[0].recurringPaymentAmount,
        "transaction_id": `${userInfo.user.userId} - ${Date.now()}`
      })
    }

    if (title.includes('Thank') || title.includes('Subscription') || title.includes('Pending') || status) {
      setTimeout(() => {
        popup.hide();

        if (title.includes('Thank'))
          window.location.href = '/'
        else
          window.location.href = window.location.origin + window.location.pathname; // use this way for not adding parameter in url

        return false;
      }, 5000);
    }
  }

  render() {
    // var message = decodeURIComponent(getQueryVariable('message'))
    const status = decodeURIComponent(getQueryVariable('status'))  
    var title = (decodeURIComponent(getQueryVariable('title')) === 'undefined') ? status : decodeURIComponent(getQueryVariable('title'));
    var message = '';

    let imgIcon, classIcon;
    setTimeout(()=>{
      Cookies.set('isThankYouPage', true)
      Cookies.set('isJusPayThankYou', true)
    },500);

    if (title.includes('Thank') || status.includes('approved')) {
      title = getLocalizedVal(window.settings,'genericMessages', 'successMessageTitle') || 'Thank you';
      message = getLocalizedVal(window.settings,'genericMessages', 'successMessage') || 'Thanks for subscribing';
      imgIcon = successIcon;
      classIcon = "icon-success";
     
    } else if (title.includes('Pending')) {
      message = getLocalizedVal(window.settings,'genericMessages', 'pendingMessage') || 'This may take upto few minutes. Please check your account settings after sometime for subscription status.';
      imgIcon = '';
      classIcon = "icon-fail";

    } else if (title.includes('Subscription') || status.includes('failed')) {
      title = getLocalizedVal(window.settings,'genericMessages', 'failMessageTitle') || 'Subscription failure';
      message = getLocalizedVal(window.settings,'genericMessages', 'failMessage') || 'Please try again.';
      imgIcon = failureIcon;
      classIcon = "icon-fail";

    } else {

      imgIcon = '';
      classIcon = "";
    }

    const loadingMessage = getLocalizedVal(window.settings, 'genericMessages', 'loadingMessage') || 'Your transaction is being processed. Please do not refresh or close the page';

    return (
      <div className="notice-popup centered padded">
        {
          this.state.loading ? <div className="loading centered">
            <div className="loading-message"> {loadingMessage} </div>
            <Spinner />
          </div>
            :
            <div>
              {imgIcon && <img className={classIcon} src={imgIcon} />}
              {(title === 'Pending') ? '' : <div className="title"> {title}!!</div>}
              <div className="message">{message}</div>
            </div>
        }
      </div>
    )
  }
}

export default Notice;
